import axios from 'axios';

export const deriveCouponErrorMessage = (err: unknown, couponCode: string): string => {
  if (axios.isAxiosError(err) && err.response?.status === 422) {
    return `${couponCode} does not exist. Check your spelling and try again`;
  }
  return 'Could not apply coupon, please try again.';
};
